import { Check, X } from "lucide-react";
import { useSite } from "@/contexts/SiteContext";
import SectionCta from "@/components/SectionCta";

// Verde folosit doar aici pentru bifele „DA” (nu există un token de brand
// pentru succes — --ct-emerald e de fapt bleumarin). Roșu-teracotă pentru
// coloana „NU” vine din tokenul existent --ct-danger.
const YES_COLOR = "#2E7D4F";
const NO_COLOR = "var(--ct-danger)";

export default function FitFilter() {
  const { sectionContent } = useSite();
  const c = sectionContent("fit_filter");
  if (!c) return null;
  const yesItems = Array.isArray(c.yes_items) ? c.yes_items : [];
  const noItems = Array.isArray(c.no_items) ? c.no_items : [];
  if (!yesItems.length && !noItems.length) return null;

  return (
    <section data-testid="fit-filter-section" className="py-14 sm:py-20 lg:py-28" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-14 max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-3 sm:mb-4">
            <span className="gold-rule" />
            <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Verifică-te pe tine"}</span>
            <span className="gold-rule" />
          </div>
          <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight">
            {c.title || "Este acest proces potrivit pentru tine?"}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 lg:gap-8">
          {yesItems.length > 0 && (
            <div className="card-premium p-6 sm:p-8" data-testid="fit-filter-yes">
              <h3 data-el="item_title" data-field="yes_title" className="font-serif text-xl sm:text-2xl mb-5" style={{ color: YES_COLOR }}>
                {c.yes_title || "Este pentru tine dacă…"}
              </h3>
              <ul className="space-y-3">
                {yesItems.map((it, i) => (
                  <li key={i} className="flex items-start gap-3" data-testid={`fit-filter-yes-${i}`}>
                    <Check size={18} className="mt-0.5 shrink-0" style={{ color: YES_COLOR }} />
                    <span data-el="item_body" data-field={`yes_items.${i}`} className="text-sm sm:text-base leading-relaxed" style={{ color: "var(--ct-text)" }}>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {noItems.length > 0 && (
            <div className="card-premium p-6 sm:p-8" data-testid="fit-filter-no">
              <h3 data-el="item_title" data-field="no_title" className="font-serif text-xl sm:text-2xl mb-5" style={{ color: NO_COLOR }}>
                {c.no_title || "NU este pentru tine dacă…"}
              </h3>
              <ul className="space-y-3">
                {noItems.map((it, i) => (
                  <li key={i} className="flex items-start gap-3" data-testid={`fit-filter-no-${i}`}>
                    <X size={18} className="mt-0.5 shrink-0" style={{ color: NO_COLOR }} />
                    <span data-el="item_body" data-field={`no_items.${i}`} className="text-sm sm:text-base leading-relaxed" style={{ color: "var(--ct-text-muted)" }}>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <SectionCta
          content={c}
          prefix="cta"
          fallbackText="Scrie-mi acum"
          fallbackLink="/programare"
          className="mt-10 sm:mt-14 text-center [&_p]:font-serif [&_p]:text-lg [&_p]:mb-5 [&>div]:flex [&>div]:flex-wrap [&>div]:justify-center"
        />
      </div>
    </section>
  );
}
